import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {MediaBox, MediaBoxHeader, MediaBoxTitle, MediaBoxBody, MediaBoxDescription} from 'react-weui'
import {ActionSheet, Mask, Tab, TabBody, NavBar, NavBarItem, LoadMore} from 'react-weui'
import Timestamp from '../Timestamp'
import qs from 'qs'
import {getTimestamp} from '../../utils'


import '../../styles/classroom/ClassroomCardPanel.css'


class ClassroomCardPanel extends React.Component {
    state = {
        currentTab: '',
        loading: false,
        items: [],
        showMenu: false,
        menus: [],
        operatingItem: null
    }

    onRequestClose() {
        this.props.dispatch({
            type: 'HIDE_CARD_PANEL'
        })
    }

    hideMenu() {
        this.setState({showMenu: false})
    }

    onSelectTab(tab) {
        this.setState({currentTab: tab, loading: true, items: []})

        const url = `/api/classroom/${this.props.lecture.id}/card/list?type=${tab}`
        axios.get(url).then((response) => {
            if (response.data.code === 0) {
                let items = []
                switch (tab) {
                    case 'lecture':
                        items = response.data.data.lectures
                        break
                    case 'channel':
                        items = response.data.data.channels
                        break
                    case 'liveroom':
                        items = response.data.data.liverooms
                        break
                    default:
                        break
                }
                this.setState({loading: false, items: items})
            }
        })
    }

    componentDidUpdate() {
        if (this.props.showCardPanel && this.state.currentTab === '') {
            this.onSelectTab('channel')
        }
    }

    onSendItem() {
        this.setState({showMenu: false})
        const {operatingItem, currentTab} = this.state
        const {timestampDelta} = this.props
        let timestamp = getTimestamp(timestampDelta)
        const url = `/api/classroom/${this.props.lecture.id}/card/send`
        const data = {
            type: currentTab,
            [currentTab + '_id']: operatingItem.id,
            ts: timestamp
        }
        axios.post(url, qs.stringify(data)).then((response) => {
            if (response.data.code === 0) {
                this.showMessage('发送成功')
                this.props.dispatch({
                    type: 'HIDE_CARD_PANEL'
                });
            }
        })
    }

    onItemClick(item) {
        const menus = []
        menus.push({
            label: '发送',
            onClick: this.onSendItem.bind(this)
        })
        this.setState({menus: menus, showMenu: true, operatingItem: item})
    }

    showMessage(text) {
        this.context.page.showToast(text)
    }

    stripTags(html) {
        let text = html.replace(/<\/?[^>]+(>|$)/g, "")
        return text
    }

    renderItem(item) {
        const {currentTab} = this.state
        if (currentTab === 'channel') {
            return <MediaBox type="appmsg" key={item.id} className="app-box"
                             onClick={e => this.onItemClick(item)}>
                <MediaBoxBody>
                    <MediaBoxTitle className="app-title">{item.name}</MediaBoxTitle>
                </MediaBoxBody>
            </MediaBox>
        } else if (currentTab === 'lecture') {
            return <MediaBox type="appmsg" key={item.id} className="app-box"
                             onClick={e => this.onItemClick(item)}>
                <MediaBoxBody>
                    <MediaBoxTitle className="app-title">{item.name}</MediaBoxTitle>
                    <MediaBoxDescription>
                        <Timestamp timestamp={item.start_timestamp}/>
                    </MediaBoxDescription>
                </MediaBoxBody>
            </MediaBox>
        } else if (currentTab === 'liveroom') {
            return <MediaBox type="appmsg" key={item.id}
                             onClick={e => this.onItemClick(item)}>
                <MediaBoxHeader className="liveroom-item">
                    <img src={item.small_avatar_url} alt="thumb"/>
                </MediaBoxHeader>
                <MediaBoxBody>
                    <MediaBoxTitle>{item.name}</MediaBoxTitle>
                    <MediaBoxDescription>
                        {this.stripTags(item.description)}
                    </MediaBoxDescription>
                </MediaBoxBody>
            </MediaBox>
        }
    }

    render() {
        if (!this.props.showCardPanel)
            return null

        const {currentTab, items, loading} = this.state

        return <div>
            <Mask onClick={this.onRequestClose.bind(this)}/>
            <div className="card-panel">
                <ActionSheet
                    menus={this.state.menus}
                    actions={[{
                        label: '取消',
                        onClick: this.hideMenu.bind(this)
                    }]}
                    show={this.state.showMenu}
                    onRequestClose={this.hideMenu.bind(this)}
                />
                <Tab>
                    <NavBar>
                        <NavBarItem active={currentTab === 'channel'}
                                    onClick={e => this.onSelectTab('channel')}>专栏</NavBarItem>
                        <NavBarItem active={currentTab === 'lecture'}
                                    onClick={e => this.onSelectTab('lecture')}>课程</NavBarItem>
                        <NavBarItem active={currentTab === 'liveroom'}
                                    onClick={e => this.onSelectTab('liveroom')}>直播间</NavBarItem>
                    </NavBar>
                    <TabBody id="material_body">
                        {loading &&
                        <LoadMore loading>加载中...</LoadMore>
                        }
                        <div className="items">
                            {items.map((m) => {
                                return this.renderItem(m)
                            })}
                        </div>
                    </TabBody>
                </Tab>
            </div>
        </div>
    }
}

ClassroomCardPanel.contextTypes = {
    page: React.PropTypes.object
}

ClassroomCardPanel.contextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    showCardPanel: state.classroom.showCardPanel,
    lecture: state.classroom.lecture,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomCardPanel)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomCardPanel.js